module.exports = __webpack_public_path__ + "static/img/SimeonThomas-Wilson.b3ec869.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SimeonThomas-Wilson.jpg
// module id = 0i7V
// module chunks = 0